<template>
  <div class="add-user-modal">
    <v-dialog v-model="dialog" :max-width="maxWidth" persistent>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
        <v-card-title class="justify-space-between">
          <div class="add-user-modal--title fw-600" :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs }">
            Add New User
          </div>
          <v-btn v-if="!breakpointXs" icon @click="$emit('cancel-user-modal', false)">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="{ 'pt-5': !breakpointXs, 'pt-0': breakpointXs }">
          <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
            <v-row>
              <v-col>
                <TextField
                  v-model="user.name"
                  rules="required"
                  showIcons
                  placeholder="John Doe"
                  :loading="isAddUserFormLoading"
                  label="Name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <TextField
                  v-model="user.email"
                  showIcons
                  rules="required|email"
                  :loading="isAddUserFormLoading"
                  label="Email"
                  placeholder="john.doe@gmail.com"
                />
              </v-col>
            </v-row>
            <v-card-actions class="d-block d-sm-flex justify-end">
              <v-btn
                color="button-primary"
                outlined
                large
                :block="breakpointXs"
                width="140"
                @click="$emit('cancel-user-modal', false)"
              >
                <span class="font-weight-bold fs-15">Cancel</span>
              </v-btn>
              <v-btn
                width="140"
                color="button-primary"
                large
                v-if="user.action == 'add'"
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="isAddUserFormLoading"
                @click="passes(addClient(user))"
              >
                <span class="font-weight-bold fs-15">Add</span>
              </v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "AddUserModal",
  components: {
    ValidationObserver,
    TextField
  },
  data() {
    return {
      dialog: true
    };
  },
  props: {
    maxWidth: {
      type: String,
      default: "450"
    },
    isAddUserFormLoading: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => {
        return {
          name: "",
          email: "",
          action: "add"
        };
      }
    }
  },
  mixins: [commonMethodsMixin],
  methods: {
    addClient(user) {
      this.$emit("add-user-modal", user);
    }
  }
};
</script>
